import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getComfortDetails, updateComfort } from "../../helpers/http_comforts_requests";
import { useQuery } from "@tanstack/react-query";

export default function ComfortUpdate() {

    const navigate = useNavigate();

    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getComfortDetails', id], 
        queryFn: () => getComfortDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: comfortData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Conforto - Editar",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        updateComfort(data, () => navigate('/confortos'));
    };

    return <DynamicFormPage 
        isLoading={isFetching} 
        initialData={comfortData} 
        title={"Conforto - Editar"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
        onSubmit={handleSubmit} 
    />;
};
